module.exports = __webpack_public_path__ + "static/media/icon-20-location-pin.cd6d4816.svg";